export default {
    namespaced: true,
    state: {
        messages: [],
        filteredMessages: []
    },
    getters: {
        filteredMessages(state) {
            return state.filteredMessages;
        },
        messages(state) {
            return state.messages;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        removeMessage(state, data) {
            for (let idx in state.messages) {
                if (state.messages[idx] && state.messages[idx].messageID === data) {
                    state.messages.splice(idx, 1);
                }
            }

            for (let idx in state.filteredMessages) {
                if (state.filteredMessages[idx] && state.filteredMessages[idx].messageID === data) {
                    state.filteredMessages.splice(idx, 1);
                }
            }
        },
        removeUserMessages(state, data) {
            for (let idx = 0; idx < state.messages.length; idx++) {
                if (state.messages[idx] && state.messages[idx].userID === data) {
                    state.messages.splice(idx, 1);
                    idx--;
                }
            }

            for (let idx = 0; idx < state.filteredMessages.length; idx++) {
                if (state.filteredMessages[idx] && state.filteredMessages[idx].userID === data) {
                    state.filteredMessages.splice(idx, 1);
                    idx--;
                }
            }
        },
        addMessage(state, data) {
            state.messages.push(data);
            if (!data.showRoomName || data.msgType === 'staff')
                state.filteredMessages.push(data);
            //let maxLen = 150;
            let removeAt = 500;
            let keep = 200;
            if (state.messages.length > removeAt && (data.scroll || state.messages.length > 300 + removeAt))
                state.messages.splice(0, state.messages.length - keep);

            if (state.filteredMessages.length > removeAt && (data.scroll || state.filteredMessages.length > 300 + removeAt))
                state.filteredMessages.splice(0, state.filteredMessages.length - keep);
        },
        messageReported(state, data) {
            let id = 0;
            let analyzeMessage = "";
            if (typeof data === "number") {
                id = data
            } else {
                id = data.id;
                if(data.type){
                    analyzeMessage = "<span class='small font-weight-bold'>[System Analyze: " + data.type + "]</span><br>";
                } else if(data.reporter){
                    analyzeMessage = "<span class='small font-weight-bold'>[Reported By: " + data.reporter + "]</span><br>";
                }
            }

            let msg = null;
            for (let idx in state.messages) {
                if (state.messages[idx] && state.messages[idx].messageID === id) {
                    state.messages[idx].reported = true;
                    state.messages[idx].content = analyzeMessage + state.messages[idx].content;
                    msg = state.messages[idx];
                }
            }
            for (let idx in state.filteredMessages) {
                if (state.filteredMessages[idx] && state.filteredMessages[idx].messageID === id) {
                    return;
                }
            }
            state.filteredMessages.push(msg);
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        removeMessage({ commit }, data) {
            commit('removeMessage', data)
        },
        removeUserMessages({ commit }, data) {
            commit('removeUserMessages', data)
        },
        addMessage({ commit }, data) {
            commit('addMessage', data)
        },
        messageReported({ commit }, id) {
            commit('messageReported', id)
        }
    }
};